<template lang="pug">
.input-textarea-horizontal
  .input-textarea-horizontal__text-before(v-if='beforeText') {{ beforeText }}
  text-area-study.input-textarea-horizontal__input(v-model='inputValue')
  .input-textarea-horizontal__text-after(v-if='afterText') {{ afterText }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextAreaStudy from '@/components/molecules/student/TextAreaStudy.vue'

/**
 * 記述式入力（横書き）
 */
@Component({
  components: {
    TextAreaStudy,
  },
})
export default class InputTextareaHorizontal extends Vue {
  // 入力値
  @Prop()
  value!: string

  // 前方テキスト
  @Prop()
  beforeText?: string

  // 後方テキスト
  @Prop()
  afterText?: string

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.input-textarea-horizontal
  &__text-before
    margin-bottom 5px
  &__text-after
    margin-top 5px
</style>
